class Debug {
  constructor (styles, debugType) {
    let el = document.createElement('div');

    for (var prop in styles) {
      el.style[prop] = styles[prop];
    }

    el.innerHTML = 'Debug initialized';
    el.classList.add('debug');

    if (debugType) {
      el.classList.add(debugType);
    }

    document.body.appendChild(el);

    this.el = el;
  }
  setText (val) {
    this.el.innerHTML = val;
  }
  show (val, time = 5000) {
    this.setText(val);
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
    this.el.classList.add('show');
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, time);
  }
  hide () {
    this.hideTimeout = null;
    this.el.classList.remove('show');
  }
}

module.exports = Debug;
